<button [type]="type" [class]="buttonClass" [disabled]="disabled || loading"
  [attr.aria-disabled]="(disabled || loading) ? 'true' : null" [attr.aria-busy]="loading ? 'true' : null"
  [attr.aria-label]="ariaLabel ? (ariaLabel | translate) : null" [attr.aria-labelledby]="ariaLabelledBy || null"
  [tooltip]="tooltip ? (tooltip | translate) : null" (click)="onClick($event)">
  @if (loading) {
  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  <span class="sr-only">{{ 'Common.Loading' | translate }}</span>
  }

  @if (!loading && icon && iconPosition === 'start') {
  <i [class]="'fa fa-' + icon" aria-hidden="true"></i>&nbsp;
  }
  <ng-content></ng-content>

  @if (!loading && icon && iconPosition === 'end') {
  &nbsp;<i [class]="'fa fa-' + icon" aria-hidden="true"></i>
  }
</button>